import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearAuthData } from '../store/slice/authSlice';
import Logo from '../assets/Logo3.png';
import { AiOutlineHome } from 'react-icons/ai';
import { CiUser, CiSettings, CiCircleQuestion } from 'react-icons/ci';
import { IoLayersOutline } from 'react-icons/io5';
import { FiTrello } from 'react-icons/fi';
import { GiAncientColumns } from 'react-icons/gi';
import { PiNotepad } from 'react-icons/pi';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MdKeyboardArrowDown, MdOutlineSupportAgent } from 'react-icons/md';
import { RiUserAddLine } from 'react-icons/ri';
import { TbReportMoney } from 'react-icons/tb';
import { GoSignOut } from 'react-icons/go';

function Aside() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({
    business: false,
    blog: false,
  });

  const toggleMenu = menu => {
    setOpenMenus(prev => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const handleLogout = () => {
    dispatch(clearAuthData());
    navigate('/');
  };

  const isActive = path => {
    if (path === '/') {
      return location.pathname === '/';
    }
    const normalizedPath = `/${path}`;
    return location.pathname === normalizedPath;
  };

  const isAnyChildActive = childPaths => {
    return childPaths.some(path => {
      const normalizedPath = `/${path}`;
      return (
        location.pathname === normalizedPath || location.pathname.startsWith(normalizedPath + '/')
      );
    });
  };

  const navItemClass = path => {
    const base = 'flex items-center font-light text-sm px-4 py-2.5 rounded-lg group';
    const active = 'bg-black text-white';
    const inactive = 'text-[#626C70] hover:bg-black hover:text-white';

    return `${base} ${isActive(path) ? active : inactive}`;
  };

  const subItemClass = path => {
    const base = 'block px-3 py-2 font-light text-sm rounded-lg group';
    const active = 'bg-black text-white';
    const inactive = 'text-[#B9B9B9] hover:bg-black hover:text-white';

    return `${base} ${isActive(path) ? active : inactive}`;
  };

  const menuButtonClass = childPaths => {
    const base =
      'flex items-center justify-between w-full px-4 py-2.5 font-light text-sm rounded-lg group';
    const active = 'bg-black text-white';
    const inactive = 'text-[#626C70] hover:bg-black hover:text-white';

    return `${base} ${isAnyChildActive(childPaths) ? active : inactive}`;
  };

  return (
    <aside className="fixed inset-y-0 left-0 z-40 flex flex-col w-64 bg-white">
      {/* Logo Section */}
      <div className="flex items-center h-20 px-4 mt-3">
        <div className="w-[101px] h-[65px]">
          <img src={Logo} alt="logo" className="mb-4 " />
          <p className="text-xs font-nohemi text-[#959FA3]">DASHBOARD</p>
        </div>
      </div>

      {/* Navigation Section */}
      <div className="flex-1 py-4 overflow-y-auto">
        <div className="px-3 pb-2 bg-white font-nohemi">
          <ul className="mt-2 space-y-1">
            <li>
              <Link to="/" className={navItemClass('/')}>
                <AiOutlineHome size={18} />
                <span className="ms-3">Dashboard</span>
              </Link>
            </li>
            <li>
              <Link to="users" className={navItemClass('users')}>
                <CiUser size={18} />
                <span className="ms-3">User Management</span>
              </Link>
            </li>
            <li>
              <Link to="industry-listing" className={navItemClass('industry-listing')}>
                <IoLayersOutline size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">Industry Listing</span>
              </Link>
            </li>
            <li>
              <button
                onClick={() => toggleMenu('business')}
                className={menuButtonClass(['business', 'business/list', 'business/report'])}>
                <div className="flex items-center">
                  <FiTrello size={18} />
                  <span className="ml-3">Business Listing</span>
                </div>
                <MdKeyboardArrowDown
                  className={`transition-transform duration-200 ${
                    openMenus.business ? 'rotate-180' : ''
                  }`}
                  size={18}
                />
              </button>
              {openMenus.business && (
                <ul className="my-3 ml-6 space-y-1">
                  <li>
                    <Link to="business" className={subItemClass('business')}>
                      Companies Request
                    </Link>
                  </li>
                  <li>
                    <Link to="business/list" className={subItemClass('business/list')}>
                      Companies/Business
                    </Link>
                  </li>
                  <li>
                    <Link to="business/report" className={subItemClass('business/report')}>
                      Reported Businesses
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link to="report" className={navItemClass('report')}>
                <GiAncientColumns size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">Reports & Analytics</span>
              </Link>
            </li>
            <li>
              <Link to="transaction" className={navItemClass('transaction')}>
                <TbReportMoney size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">Transactions</span>
              </Link>
            </li>
            <li>
              <Link to="support" className={navItemClass('support')}>
                <MdOutlineSupportAgent size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">Support</span>
              </Link>
            </li>

            {/* Others Section */}
            <div className="mt-6 ml-4">
              <p className="text-[9px] font-light p-1 text-[#626C70]">OTHERS</p>
            </div>

            <li>
              <Link to="settings" className={navItemClass('settings')}>
                <CiSettings size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">Settings</span>
              </Link>
            </li>
            <li>
              <Link to="admin-management" className={navItemClass('admin-management')}>
                <RiUserAddLine size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">Create Admin</span>
              </Link>
            </li>
            <li>
              <button
                onClick={() => toggleMenu('blog')}
                className={menuButtonClass(['blog', 'blog/manage'])}>
                <div className="flex items-center">
                  <PiNotepad size={18} />
                  <span className="ml-3">Blog Management</span>
                </div>
                <MdKeyboardArrowDown
                  className={`transition-transform duration-200 ${
                    openMenus.blog ? 'rotate-180' : ''
                  }`}
                  size={18}
                />
              </button>
              {openMenus.blog && (
                <ul className="my-3 ml-6 space-y-1">
                  <li>
                    <Link to="blog" className={subItemClass('blog')}>
                      <span className="flex-1 whitespace-nowrap">Post Blog</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="blog/manage" className={subItemClass('blog/manage')}>
                      <span className="flex-1 whitespace-nowrap">Manage My Blog</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link to="faq" className={navItemClass('faq')}>
                <CiCircleQuestion size={18} />
                <span className="flex-1 ms-3 whitespace-nowrap">FAQ</span>
              </Link>
            </li>
            <li>
              <button
                onClick={handleLogout}
                className="flex items-center font-light text-sm px-4 py-2.5 text-[#626C70] rounded-lg hover:bg-black hover:text-white group transition-colors duration-200 w-full">
                <GoSignOut size={18} className="rotate-180" />
                <span className="ms-3">Log Out</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
}

export default Aside;
